/**
 * Runtime widget for pages that will be unpublished soon.
 */
Vue.asyncComponent('cms-dashboard-upcoming-pages-offline', {
    props: {
        title: {
            type: String,
            default: '',
        },
        items: {
            type: Array,
            default: () => [],
        },
        moreHref: {
            type: String,
            default: '',
        },
        moreLabel: {
            type: String,
            default: '',
        },
        emptyText: {
            type: String,
            default: '',
        },
    },
}, 'cms/dashboard/live/cms-dashboard-upcoming-pages-offline.html');
